import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import MediaObjectFullDetails from '@components/MediaObject/Full/Details/Details'
import MediaObjectFullMedia from '@components/MediaObject/Full/Media/Media'
import Breakpoint from '@components/UI/Breakpoint'
import { FullGridArea, FullHr, FullStyled } from '@components/UI/Full/Full.styled'
import FullLoading from '@components/UI/Full/Loading'
import { SHAREABLE_CONTENT_LIBRARY } from '@constants'
import { IApplicationState } from '@store'
import {
  fetchShareableMediaObject,
  selectIsLoadingFullPage,
  selectShareableContentLibraryMediaObjectIds,
} from '@store/mediaObjects'
import { isEmpty } from '@utils'
import ShareableContentLibraryFullPricePanel from './PricePanel'

interface IParams {
  token: string
  mediaObjectId?: string
}

const ShareableContentLibraryFull: React.FC = () => {
  const { token, mediaObjectId: mediaObjectIdParam } = useParams<IParams>()
  const mediaObjectId = mediaObjectIdParam ? parseInt(mediaObjectIdParam, 10) : undefined

  const dispatch = useDispatch()
  const isLoading = useSelector((state: IApplicationState) =>
    selectIsLoadingFullPage(state, SHAREABLE_CONTENT_LIBRARY, mediaObjectId),
  )
  const hasMediaObjects = useSelector(
    (state: IApplicationState) => !isEmpty(selectShareableContentLibraryMediaObjectIds(state)),
  )

  React.useEffect(() => {
    if (!hasMediaObjects && mediaObjectId !== undefined) {
      dispatch(fetchShareableMediaObject(token, mediaObjectId))
    }
  }, [])

  if (isLoading) {
    return <FullLoading alternatePricePosition />
  }

  if (mediaObjectId === undefined) {
    return null
  }

  return (
    <FullStyled layoutStyle="branded_cl">
      <FullGridArea name="media">
        <MediaObjectFullMedia />
      </FullGridArea>
      <FullGridArea name="price">
        <Breakpoint desktop tabletLandscape>
          <FullHr />
        </Breakpoint>
        <ShareableContentLibraryFullPricePanel key={mediaObjectId} mediaObjectId={mediaObjectId} />
        <Breakpoint tabletPortrait mobile>
          <FullHr />
        </Breakpoint>
      </FullGridArea>
      <FullGridArea name="details" cssOverflow>
        <MediaObjectFullDetails />
      </FullGridArea>
    </FullStyled>
  )
}

export { ShareableContentLibraryFull }
export default ShareableContentLibraryFull
